<script setup lang="ts">
import { useFeedbackPanelStore } from '../stores/feedbackPanel';
import '../styles/feedback.css';

/** Lot AQ : bulle ronde « Faire un retour », au-dessus de celle de l'assistant (maquette retours-1410, repère 1). */
const store = useFeedbackPanelStore();
</script>

<template>
  <button
    class="fab-fb"
    type="button"
    aria-label="Faire un retour"
    data-testid="feedback-fab"
    @click="store.show()"
  >
    <span class="fab-fb-tip" aria-hidden="true">Faire un retour</span>
    <svg
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path
        d="M4 3.5h12A1.5 1.5 0 0 1 17.5 5v7.5A1.5 1.5 0 0 1 16 14h-6l-4 3.2V14H4a1.5 1.5 0 0 1-1.5-1.5V5A1.5 1.5 0 0 1 4 3.5z"
      />
      <path d="M10 6.6v3.6" stroke-linecap="round" />
      <circle cx="10" cy="12" r=".4" fill="currentColor" />
    </svg>
  </button>
</template>
